function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B8C8CC;}\n\t.st1{opacity:0.21;}\n\t.st2{fill:none;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5913"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5911",
  transform: "translate(-137.403 -119.867)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_2674",
  transform: "translate(147.212 121.696) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7.6,11.4H3.4c-2.1,0-3.7-1.7-3.7-3.7V3.4c0-2.1,1.7-3.7,3.7-3.7h2.3C5.9-0.3,6-0.2,6,0v0.8 c0,0.2-0.1,0.3-0.3,0.3H3.4c-1.3,0-2.4,1.1-2.4,2.4v4.2c0,1.3,1.1,2.4,2.4,2.4h4.2C8.9,10,10,8.9,10,7.6V5.3 C10,5.2,10.1,5,10.3,5h0.8c0.2,0,0.3,0.1,0.3,0.3v2.3C11.4,9.7,9.7,11.4,7.6,11.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5912"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.8,13.1c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l2.2-2.2l-2.2-2.2c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0L19,9.1c0.3,0.3,0.3,0.8,0,1.1l-2.7,2.7C16.2,13.1,16,13.1,15.8,13.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.5,10.4h-6.2c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h6.2c0.4,0,0.8,0.3,0.8,0.8S18.9,10.4,18.5,10.4z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_5914",
  transform: "translate(-1 1)",
  className: "st1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5911-2",
  transform: "translate(-137.403 -119.867)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_2674-2",
  transform: "translate(147.212 121.696) rotate(45)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.7,0 M7.6,11.4H3.4c-2.1,0-3.7-1.7-3.7-3.7V3.4c0-2.1,1.7-3.7,3.7-3.7h2.3C5.9-0.3,6-0.2,6,0v0.8 c0,0.2-0.1,0.3-0.3,0.3H3.4c-1.3,0-2.4,1.1-2.4,2.4v4.2c0,1.3,1.1,2.4,2.4,2.4h4.2C8.9,10,10,8.9,10,7.6V5.3 C10,5.2,10.1,5,10.3,5h0.8c0.2,0,0.3,0.1,0.3,0.3v2.3C11.4,9.7,9.7,11.4,7.6,11.4z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5912-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15.8,13.1c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.8,0-1.1l2.2-2.2l-2.2-2.2c-0.3-0.3-0.3-0.8,0-1.1 c0.3-0.3,0.8-0.3,1.1,0L19,9.1c0.3,0.3,0.3,0.8,0,1.1l-2.7,2.7C16.2,13.1,16,13.1,15.8,13.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.5,10.4h-6.2c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h6.2c0.4,0,0.8,0.3,0.8,0.8 C19.3,10.1,18.9,10.4,18.5,10.4z"
})));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1124",
  className: "st2",
  width: 20,
  height: 20
});

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "share-web",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.92ce8c7c.svg";
export { ForwardRef as ReactComponent };